import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { captureAffiliateParams } from "@/lib/affiliateTracking";

/**
 * Global affiliate click capture — mounts once at app root.
 * Logs new affiliate clicks to affiliate_clicks table (anon-safe, fire-and-forget).
 * First-touch wins: no re-capture on subsequent page loads within the same session.
 */
export default function AffiliateTracker() {
  useEffect(() => {
    const result = captureAffiliateParams();
    if (!result?.isNew) return; // existing session or no params

    const { params } = result;

    supabase.from("affiliate_clicks" as any).insert({
      click_id:     params.click_id,
      landing_page: params.landing_page,
      referrer:     document.referrer || null,
      sub_id1:      params.sub_id1 ?? null,
      sub_id2:      params.sub_id2 ?? null,
      sub_id3:      params.sub_id3 ?? null,
      sub_id4:      params.sub_id4 ?? null,
      source:       params.source  ?? null,
      medium:       params.medium  ?? null,
      ref:          params.ref     ?? null,
    }).then(({ error }) => {
      if (error) console.warn("[AffiliateTracker] click log failed", error);
    });
  }, []);

  return null;
}
